import { isCompatible, navigateToBrowserCompat } from "@suse-o11y/legacy/main/browser_compat/common";

const searchParams = new URLSearchParams(location.search);
const isSkipCheck = searchParams.get("skip_check") === "true";

if (!(isSkipCheck || isCompatible())) {
	navigateToBrowserCompat(location.href);
}
